import { AudioTrack } from "providers/AudioProvider/types";
import { FRAGMENT_MIN_HEIGHT } from "components/utils";

export interface CaptionConflictGroup {
    key: string;
    entries: { track: AudioTrack; index: number }[];
    duplicateIds: string[];
}

/** Group intersecting caption rectangles, without changing the media timeline or choosing a survivor. */
export function captionConflicts(tracks: AudioTrack[], msPerPixel: number): CaptionConflictGroup[] {
    if (!Number.isFinite(msPerPixel) || msPerPixel <= 0) return [];
    const counts = new Map<string, number>();
    tracks.forEach((track) => counts.set(track.id, (counts.get(track.id) || 0) + 1));
    const ordered = tracks.map((track, index) => ({ track, index }))
        .filter(({ track }) => Number.isFinite(track.start))
        .sort((a, b) => a.track.start - b.track.start || a.index - b.index);
    const groups: CaptionConflictGroup[] = [];
    let entries: CaptionConflictGroup["entries"] = [];
    let bottom = -Infinity;
    const finish = () => {
        const duplicateIds = Array.from(new Set(entries.filter(({ track }) => counts.get(track.id)! > 1)
            .map(({ track }) => track.id)));
        if (entries.length > 1 || duplicateIds.length) {
            groups.push({ key: entries.map(({ track, index }) => `${index}:${track.id}`).join("|"), entries, duplicateIds });
        }
    };
    for (const entry of ordered) {
        const { track } = entry;
        if (track.start >= bottom) {
            finish();
            entries = [];
            bottom = -Infinity;
        }
        entries.push(entry);
        bottom = Math.max(bottom, track.start + Math.max(Number(track.length) || 0, FRAGMENT_MIN_HEIGHT * msPerPixel));
    }
    finish();
    return groups;
}
